import { Provider } from "react-redux";
import AddOnsBilling from "./AddOnsBilling";
import { useMemo } from "react";

const AddOnsBillingApp = () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      <AddOnsBilling />
    </Provider>
  );
};

export default AddOnsBillingApp;
